/**
 * Phantom Display — Nav JS (Shopify)
 * Sticky header, mega menu, mobile menu, keyboard controls.
 * Hooks into Aurora's cart drawer + search sidebar via data attributes.
 */

document.addEventListener('DOMContentLoaded', () => {

  const wrapper = document.getElementById('phantom-header');
  if (!wrapper) return;

  // ========================================
  // STICKY HEADER
  // ========================================
  const header = wrapper.querySelector('#siteHeader');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 20);
    }, { passive: true });
  }

  // ========================================
  // MEGA MENU
  // 200ms open delay, 300ms close delay (hover intent)
  // ========================================
  const shopTrigger = wrapper.querySelector('#shopTrigger');
  const megaMenu = wrapper.querySelector('#megaMenu');
  const pageOverlay = wrapper.querySelector('#pageOverlay');

  let megaOpenTimer = null;
  let megaCloseTimer = null;

  function openMega() {
    if (!megaMenu) return;
    clearTimeout(megaCloseTimer);
    clearTimeout(megaOpenTimer);
    megaMenu.classList.add('open');
    if (shopTrigger) {
      shopTrigger.classList.add('active-section');
      shopTrigger.setAttribute('aria-expanded', 'true');
    }
    if (header) header.classList.add('mega-open');
    if (pageOverlay) pageOverlay.classList.add('active');
  }

  function closeMega() {
    if (!megaMenu) return;
    clearTimeout(megaOpenTimer);
    clearTimeout(megaCloseTimer);
    megaMenu.classList.remove('open');
    if (shopTrigger) {
      shopTrigger.classList.remove('active-section');
      shopTrigger.setAttribute('aria-expanded', 'false');
    }
    if (header) header.classList.remove('mega-open');
    if (pageOverlay) pageOverlay.classList.remove('active');
  }

  if (shopTrigger && megaMenu) {
    const navWrap = shopTrigger.closest('.nav-item--has-mega');

    // Hover intent (desktop only)
    if (navWrap) {
      navWrap.addEventListener('mouseenter', () => {
        if (window.innerWidth <= 1024) return;
        clearTimeout(megaCloseTimer);
        megaOpenTimer = setTimeout(openMega, 80);
      });
      navWrap.addEventListener('mouseleave', () => {
        if (window.innerWidth <= 1024) return;
        clearTimeout(megaOpenTimer);
        megaCloseTimer = setTimeout(closeMega, 450);
      });
    }

    megaMenu.addEventListener('mouseenter', () => {
      clearTimeout(megaCloseTimer);
    });
    megaMenu.addEventListener('mouseleave', () => {
      megaCloseTimer = setTimeout(closeMega, 450);
    });

    // Click toggle
    shopTrigger.addEventListener('click', (e) => {
      e.preventDefault();
      if (megaMenu.classList.contains('open')) {
        closeMega();
      } else {
        openMega();
      }
    });
  }

  // ========================================
  // PAGE OVERLAY — click to close
  // ========================================
  if (pageOverlay) {
    pageOverlay.addEventListener('click', () => {
      closeMega();
    });
  }

  // ========================================
  // SEARCH — open Aurora's search sidebar
  // ========================================
  const searchBtn = wrapper.querySelector('#phantomSearchBtn');
  if (searchBtn) {
    searchBtn.addEventListener('click', () => {
      closeMega();
      const auroraSearchBtn = document.querySelector('[data-sidebar-button][data-sidebar-id="SearchSidebar"]');
      if (auroraSearchBtn) {
        auroraSearchBtn.click();
      }
    });
  }

  // Mobile search input — now handled by scoped search in mobile menu JS below

  // ========================================
  // MOBILE MENU — full-screen overlay (view-based navigation)
  // ========================================
  const menuToggle = wrapper.querySelector('#menuToggle');
  const mobileMenu = wrapper.querySelector('#mobileMenu');
  const mobileClose = wrapper.querySelector('#mobileClose');
  const mobMenuBody = wrapper.querySelector('#mobMenuBody');

  // Search elements (inline overlay in main nav)
  const searchInput = wrapper.querySelector('#mobSearchInput');
  const searchOverlay = wrapper.querySelector('#mobSearchOverlay');
  const searchDefault = wrapper.querySelector('#mobSearchDefault');
  const searchResults = wrapper.querySelector('#mobSearchResults');
  const searchResultsList = wrapper.querySelector('#mobSearchResultsList');
  const searchNoResults = wrapper.querySelector('#mobSearchNoResults');
  const searchNoResultsQuery = wrapper.querySelector('#mobSearchNoResultsQuery');
  const searchClear = wrapper.querySelector('#mobSearchClear');

  // --- Open / Close ---

  function openMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('open');
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    document.body.style.top = '-' + window.scrollY + 'px';
  }

  function closeMobileMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('open');
    const scrollY = document.body.style.top;
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.width = '';
    document.body.style.top = '';
    window.scrollTo(0, parseInt(scrollY || '0') * -1);
    // Hide search overlay and clear input
    if (searchOverlay) {
      searchOverlay.classList.remove('mob-search-overlay--active', 'mob-search-overlay--visible');
    }
    if (searchInput) { searchInput.value = ''; searchInput.blur(); }
    // Reset to top view after close animation
    setTimeout(() => {
      navigateMobView('top', 'back', true);
    }, 300);
  }

  if (menuToggle) menuToggle.addEventListener('click', openMobileMenu);
  if (mobileClose) mobileClose.addEventListener('click', closeMobileMenu);

  // --- View Navigation State Machine ---

  let currentMobView = 'top';
  let mobAnimating = false;

  function navigateMobView(targetId, direction, silent) {
    if (mobAnimating && !silent) return;

    const currentEl = wrapper.querySelector('#mob-view-' + currentMobView);
    const targetEl = wrapper.querySelector('#mob-view-' + targetId);
    if (!targetEl) return;

    if (silent) {
      // Instant switch (used after menu close)
      wrapper.querySelectorAll('.mob-view').forEach(v => v.classList.remove('mob-view--active'));
      targetEl.classList.add('mob-view--active');
      // Hide all footers
      wrapper.querySelectorAll('.mob-subnav-footer').forEach(f => f.classList.remove('mob-subnav-footer--active'));
      currentMobView = targetId;
      return;
    }

    mobAnimating = true;

    // Apply exit animation to current view
    if (currentEl) {
      currentEl.style.transition = 'transform 0.18s ease-out, opacity 0.18s ease-out';
      currentEl.style.transform = direction === 'forward' ? 'translateX(-30px)' : 'translateX(30px)';
      currentEl.style.opacity = '0';
    }

    setTimeout(() => {
      // Swap visibility
      if (currentEl) {
        currentEl.classList.remove('mob-view--active');
        currentEl.style.transition = '';
        currentEl.style.transform = '';
        currentEl.style.opacity = '';
      }

      // Prepare target for entry
      targetEl.style.transform = direction === 'forward' ? 'translateX(30px)' : 'translateX(-30px)';
      targetEl.style.opacity = '0';
      targetEl.classList.add('mob-view--active');

      // Force reflow then animate in
      targetEl.offsetHeight;
      targetEl.style.transition = 'transform 0.18s ease-out, opacity 0.18s ease-out';
      targetEl.style.transform = 'translateX(0)';
      targetEl.style.opacity = '1';

      // Reset scroll
      if (mobMenuBody) mobMenuBody.scrollTop = 0;

      // Show/hide sub-nav footers
      updateMobFooter(targetId);

      currentMobView = targetId;

      setTimeout(() => {
        targetEl.style.transition = '';
        targetEl.style.transform = '';
        targetEl.style.opacity = '';
        mobAnimating = false;
      }, 200);

      // (Search is now inline — no separate view to navigate to)
    }, 180);
  }

  function updateMobFooter(viewId) {
    wrapper.querySelectorAll('.mob-subnav-footer').forEach(f => {
      f.classList.remove('mob-subnav-footer--active');
    });
    const footer = wrapper.querySelector('#mob-footer-' + viewId);
    if (footer) footer.classList.add('mob-subnav-footer--active');
  }

  // --- Navigation Event Listeners ---

  // data-mob-navigate triggers
  wrapper.querySelectorAll('[data-mob-navigate]').forEach(el => {
    el.addEventListener('click', (e) => {
      e.preventDefault();
      const target = el.getAttribute('data-mob-navigate');
      const direction = target === 'top' ? 'back' : 'forward';
      navigateMobView(target, direction);
    });
  });

  // Close buttons inside views
  wrapper.querySelectorAll('.mob-view-close').forEach(btn => {
    btn.addEventListener('click', closeMobileMenu);
  });

  // Product row links
  wrapper.querySelectorAll('[data-mob-link]').forEach(row => {
    row.addEventListener('click', () => {
      const href = row.getAttribute('data-mob-link');
      if (href && href !== '#') {
        closeMobileMenu();
        setTimeout(() => { window.location.href = href; }, 300);
      }
    });
  });

  // CTA links in footers (close menu on click)
  wrapper.querySelectorAll('.mob-subnav-footer a').forEach(link => {
    link.addEventListener('click', () => {
      closeMobileMenu();
    });
  });

  // Utility links (close menu on click, let default navigation happen)
  wrapper.querySelectorAll('.mob-util-link').forEach(link => {
    link.addEventListener('click', () => {
      closeMobileMenu();
    });
  });

  // Bundle accordion toggles
  wrapper.querySelectorAll('.mob-bundle-toggle').forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const card = btn.closest('.mob-bundle-card');
      const includes = card.querySelector('.mob-bundle-includes');
      const isOpen = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
      includes.classList.toggle('mob-bundle-includes--open', !isOpen);
    });
  });

  // Bundle card link clicks (not on toggle or CTA)
  wrapper.querySelectorAll('.mob-bundle-card[data-mob-link]').forEach(card => {
    card.addEventListener('click', () => {
      const url = card.dataset.mobLink;
      if (url) { closeMobileMenu(); window.location.href = url; }
    });
  });

  // Press feedback handled by CSS :active pseudo-class (no JS class toggling needed)

  // --- Swipe-to-Go-Back ---

  wrapper.querySelectorAll('.mob-view').forEach(view => {
    if (view.id === 'mob-view-top') return; // no swipe on top view
    let touchStartX = 0;
    let touchStartY = 0;
    view.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
    }, { passive: true });
    view.addEventListener('touchend', (e) => {
      const dx = e.changedTouches[0].clientX - touchStartX;
      const dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
      // Swipe right at least 60px, more horizontal than vertical
      if (dx > 60 && dy < dx * 0.75) {
        navigateMobView('top', 'back');
      }
    }, { passive: true });
  });

  // --- Search (Shopify Predictive Search API) ---

  function escapeHtml(str) {
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  let searchTimer = null;
  let searchAbort = null;
  const searchCache = new Map();
  const SEARCH_CACHE_MAX = 50;

  function cacheSet(query, products) {
    if (searchCache.size >= SEARCH_CACHE_MAX) {
      searchCache.delete(searchCache.keys().next().value);
    }
    searchCache.set(query, products);
  }

  function isBundle(p) {
    if (!p) return false;
    if ((p.type || '').toLowerCase() === 'bundle') return true;
    const tags = p.tags;
    if (Array.isArray(tags) && tags.some(t => String(t).toLowerCase() === 'bundle')) return true;
    return false;
  }

  function navigateToFullSearch(query) {
    if (!query) return;
    const href = '/search?q=' + encodeURIComponent(query);
    closeMobileMenu();
    setTimeout(() => { window.location.href = href; }, 300);
  }

  function performSearch(query) {
    if (!searchDefault || !searchResults || !searchNoResults) return;
    if (searchClear) searchClear.style.display = query.length > 0 ? '' : 'none';

    if (query.length < 2) {
      if (searchTimer) { clearTimeout(searchTimer); searchTimer = null; }
      if (searchAbort) { searchAbort.abort(); searchAbort = null; }
      searchDefault.style.display = '';
      searchResults.style.display = 'none';
      searchNoResults.style.display = 'none';
      return;
    }

    // Cache hit — render instantly
    if (searchCache.has(query)) {
      if (searchTimer) { clearTimeout(searchTimer); searchTimer = null; }
      if (searchAbort) { searchAbort.abort(); searchAbort = null; }
      renderResults(query, searchCache.get(query));
      return;
    }

    if (searchTimer) clearTimeout(searchTimer);
    if (searchAbort) searchAbort.abort();

    searchTimer = setTimeout(() => {
      searchAbort = new AbortController();
      const url = '/search/suggest.json?q=' + encodeURIComponent(query) +
                  '&resources[type]=product&resources[limit]=10' +
                  '&resources[options][unavailable_products]=last';
      fetch(url, { signal: searchAbort.signal })
        .then(r => r.json())
        .then(data => {
          let products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
          products = products.filter(p => !isBundle(p)).slice(0, 8);
          cacheSet(query, products);
          renderResults(query, products);
        })
        .catch(err => { if (err.name !== 'AbortError') console.warn('search', err); });
    }, 80);
  }

  function renderResults(query, products) {
    searchDefault.style.display = 'none';
    if (!products.length) {
      searchResults.style.display = 'none';
      searchNoResults.style.display = '';
      if (searchNoResultsQuery) searchNoResultsQuery.textContent = query;
      return;
    }
    searchNoResults.style.display = 'none';
    searchResults.style.display = '';

    let html = '';
    products.forEach((p, i) => {
      const isLast = i === products.length - 1;
      const img = (p.featured_image && p.featured_image.url) || p.image || '';
      const url = p.url || '#';
      const title = p.title || '';
      html += '<div class="mob-search-result' + (isLast ? '' : ' mob-search-result--bordered') + '" data-mob-link="' + escapeHtml(url) + '">';
      html += '<div class="mob-search-result__thumb">';
      html += img
        ? '<img src="' + escapeHtml(img) + '" alt="" style="width:88px;height:88px;border-radius:10px;object-fit:cover;display:block;" loading="lazy">'
        : '<div style="width:88px;height:88px;border-radius:10px;background:linear-gradient(135deg,#6a5a48,#8a7558);"></div>';
      html += '</div>';
      html += '<div class="mob-search-result__info">';
      html += '<span class="mob-search-result__name">' + escapeHtml(title) + '</span>';
      html += '</div>';
      html += '<svg class="mob-row__chevron" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M5 3L9 7L5 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      html += '</div>';
    });
    html += '<div class="mob-search-viewall" data-mob-link="/search?q=' + encodeURIComponent(query) + '">';
    html += '<span>View all results for &ldquo;' + escapeHtml(query) + '&rdquo;</span>';
    html += '<svg width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M5 3L9 7L5 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';
    html += '</div>';
    searchResultsList.innerHTML = html;

    searchResultsList.querySelectorAll('[data-mob-link]').forEach(row => {
      row.addEventListener('click', () => {
        const href = row.getAttribute('data-mob-link');
        if (href && href !== '#') {
          closeMobileMenu();
          setTimeout(() => { window.location.href = href; }, 300);
        }
      });
    });
  }

  // --- Search Overlay Show/Hide ---

  function showSearchOverlay() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('mob-search-overlay--active');
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        searchOverlay.classList.add('mob-search-overlay--visible');
      });
    });
  }

  function hideSearchOverlay() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('mob-search-overlay--visible');
    setTimeout(() => {
      searchOverlay.classList.remove('mob-search-overlay--active');
    }, 150);
  }

  if (searchInput) {
    searchInput.addEventListener('focus', () => {
      showSearchOverlay();
      performSearch(searchInput.value.trim());
    });

    searchInput.addEventListener('input', () => {
      performSearch(searchInput.value.trim());
    });

    searchInput.addEventListener('keydown', (e) => {
      if (e.key === 'Enter') {
        const q = searchInput.value.trim();
        if (q.length > 0) {
          e.preventDefault();
          navigateToFullSearch(q);
        }
      }
    });
  }

  if (searchClear) {
    searchClear.addEventListener('click', () => {
      if (searchInput) {
        searchInput.value = '';
        performSearch('');
        searchInput.focus();
      }
    });
  }

  // Close overlay when tapping outside the search inline area
  if (mobMenuBody && searchOverlay) {
    mobMenuBody.addEventListener('click', (e) => {
      const inlineWrap = wrapper.querySelector('#mobSearchInline');
      if (inlineWrap && !inlineWrap.contains(e.target)) {
        hideSearchOverlay();
        if (searchInput) searchInput.blur();
      }
    });
  }

  // --- Quiz Link Handling ---

  wrapper.querySelectorAll('a[href*="find-your-display"]').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
      const isMenuOpen = mobileMenu && mobileMenu.classList.contains('open');
      closeMega();
      closeMobileMenu();
      setTimeout(() => {
        window.location.href = '/pages/find-your-display';
      }, isMenuOpen ? 400 : 50);
    });
  });

  // ========================================
  // KEYBOARD — Escape closes everything
  // ========================================
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeMega();
      closeMobileMenu();
    }
  });

  // ========================================
  // SCROLL — close mega menu
  // ========================================
  window.addEventListener('scroll', () => {
    if (megaMenu && megaMenu.classList.contains('open')) closeMega();
  }, { passive: true });

  // ========================================
  // CART COUNT — live updates
  // Listen for Shopify section rendering events
  // ========================================
  function updateCartCount(count) {
    const badges = wrapper.querySelectorAll('.cart-count');
    badges.forEach(badge => {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // Listen for Aurora's cart update via section rendering API
  document.addEventListener('cart:change', (e) => {
    if (e.detail && typeof e.detail.itemCount !== 'undefined') {
      updateCartCount(e.detail.itemCount);
    }
  });

  // Fallback: poll cart.js on section render events
  const cartCountObserver = new MutationObserver(() => {
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => {
        updateCartCount(data.item_count);
        syncCartDrawerState(data);
      })
      .catch(() => {});
  });

  // Watch for cart drawer content changes (use getElementById, NOT querySelector
  // for data-sidebar-id which matches the header button, not the drawer)
  const cartDrawer = document.getElementById('CartDrawer');
  if (cartDrawer) {
    cartCountObserver.observe(cartDrawer, { childList: true, subtree: true });
  }

  /* Keep cart drawer attributes and free shipping bar in sync with actual
     cart state. Aurora's internal update can miss the is-empty toggle and
     free-shipping-bar refresh on the first empty-to-non-empty transition. */
  function syncCartDrawerState(cart) {
    if (!cartDrawer) return;
    var hasItems = cart.item_count > 0;

    /* Remove is-empty / empty-cart when cart has items */
    if (hasItems) {
      cartDrawer.removeAttribute('is-empty');
      cartDrawer.removeAttribute('empty-cart');
    }

    /* Update free shipping bar if it exists */
    var bar = cartDrawer.querySelector('free-shipping-bar');
    if (!bar || typeof bar.updateProgressByDifference !== 'function') return;
    var thresholdDollars = parseFloat(cartDrawer.dataset.freeShippingThreshold || '0');
    if (!thresholdDollars) return;
    var thresholdCents = thresholdDollars * 100;
    var diff = thresholdCents - cart.total_price;
    var pct = (cart.total_price / thresholdCents) * 100;
    var diffFormatted = '$' + (Math.max(0, diff) / 100).toFixed(2);
    if (diff <= 0) pct = 100;
    bar.updateProgressByDifference(diffFormatted, pct);
  }

  // Also listen for Shopify's section rendering events
  document.addEventListener('shopify:section:load', () => {
    fetch('/cart.js')
      .then(r => r.json())
      .then(data => updateCartCount(data.item_count))
      .catch(() => {});
  });

  // Initial cart count visibility
  const initialBadges = wrapper.querySelectorAll('.cart-count');
  initialBadges.forEach(badge => {
    const count = parseInt(badge.textContent, 10);
    badge.style.display = count > 0 ? 'flex' : 'none';
  });

  // ========================================
  // ACTIVE PAGE INDICATOR
  // ========================================
  const path = window.location.pathname;
  wrapper.querySelectorAll('.main-nav .nav-link[href]').forEach(link => {
    const href = link.getAttribute('href');
    if (href && path.startsWith(href) && href !== '/') {
      link.classList.add('active');
    }
  });
  // Highlight "Shop" trigger on product/collection pages
  if (shopTrigger && (path.startsWith('/products') || path.startsWith('/collections'))) {
    shopTrigger.classList.add('active-section');
  }

});
